module.exports = __webpack_public_path__ + "img/type4.3d840f38.png";